// IMAGES
import image1 from "./images-dark/dark1.png";
import image2 from "./images-dark/dark2.png";
import image3 from "./images-dark/dark3.png";
import image4 from "./images-dark/dark4.png";
import image5 from "./images-dark/dark5.png";
import image6 from "./images-dark/dark6.png";
import image7 from "./images-dark/dark7.png";
import image8 from "./images-dark/dark8.png";
import image9 from "./images-dark/dark19.png";
import image10 from "./images-dark/dark10.png";
import image11 from "./images-dark/dark11.png";
import image12 from "./images-dark/dark12.png";
import image13 from "./images-dark/dark13.png";
import image14 from "./images-dark/dark14.png";
import image15 from "./images-dark/dark15.png";
import image16 from "./images-dark/dark16.png";
import image17 from "./images-dark/dark17.png";
import image18 from "./images-dark/dark18.png";
import image19 from "./images-dark/dark9.png";
import image20 from "./images-dark/dark20.png";
import image21 from "./images-dark/dark21.png";
import image22 from "./images-dark/dark22.png";
import image23 from "./images-dark/dark23.png";
import image24 from "./images-dark/dark24.png";
import image25 from "./images-dark/dark25.png";

// SONGS
import song1 from "./mp3-dark/AHS.mp3";
import song2 from "./mp3-dark/Alien.mp3";
import song3 from "./mp3-dark/Exorcist.mp3";
import song4 from "./mp3-dark/Chucky.mp3";
import song5 from "./mp3-dark/Saw.mp3";
import song6 from "./mp3-dark/Freddy.mp3";
import song7 from "./mp3-dark/Ghostbusters.mp3";
import song8 from "./mp3-dark/Halloween.mp3";
import song9 from "./mp3-dark/Psycho.mp3";
import song10 from "./mp3-dark/Hellraiser.mp3";
import song11 from "./mp3-dark/HillsHaveEyes.mp3";
import song12 from "./mp3-dark/TheThing.mp3";
import song13 from "./mp3-dark/Jaws.mp3";
import song14 from "./mp3-dark/Leatherface.mp3";
import song15 from "./mp3-dark/Nosferatu.mp3";
import song16 from "./mp3-dark/Prometheus.mp3";
import song17 from "./mp3-dark/Halloween3.mp3";
import song18 from "./mp3-dark/Beetlejuice.mp3";
import song19 from "./mp3-dark/SilentHill.mp3";
import song20 from "./mp3-dark/StrangerThings.mp3";
import song21 from "./mp3-dark/TheOmen.mp3";
import song22 from "./mp3-dark/Jason.mp3";
import song23 from "./mp3-dark/TwilightZone.mp3";
import song24 from "./mp3-dark/XFiles.mp3";
import song25 from "./mp3-dark/MrJack.mp3";

// LOTTIE
import lottie1 from "./lotties-dark/AHS.json";
import lottie2 from "./lotties-dark/Alien.json";
import lottie3 from "./lotties-dark/Exorcist.json";
import lottie4 from "./lotties-dark/Chucky.json";
import lottie5 from "./lotties-dark/Saw.json";
import lottie6 from "./lotties-dark/Freddy.json";
import lottie7 from "./lotties-dark/Ghostbusters.json";
import lottie8 from "./lotties-dark/Halloween.json";
import lottie9 from "./lotties-dark/Psycho.json";
import lottie10 from "./lotties-dark/Hellraiser.json";
import lottie11 from "./lotties-dark/HillsHaveEyes.json";
import lottie12 from "./lotties-dark/TheThing.json";
import lottie13 from "./lotties-dark/Jaws.json";
import lottie14 from "./lotties-dark/Leatherface.json";
import lottie15 from "./lotties-dark/Nosferatu.json";
import lottie16 from "./lotties-dark/Prometheus.json";
import lottie17 from "./lotties-dark/Halloween3.json";
import lottie18 from "./lotties-dark/Beetlejuice.json";
import lottie19 from "./lotties-dark/SilentHill.json";
import lottie20 from "./lotties-dark/StrangerThings.json";
import lottie21 from "./lotties-dark/TheOmen.json";
import lottie22 from "./lotties-dark/Jason.json";
import lottie23 from "./lotties-dark/TwilightZone.json";
import lottie24 from "./lotties-dark/XFiles.json";
import lottie25 from "./lotties-dark/MrJack.json";

const darkCalendar = [
  {
    number: "1",
    image: image1,
    lottie: lottie1,
    url: song1,
  },
  {
    number: "2",
    image: image2,
    lottie: lottie2,
    url: song2,
  },
  {
    number: "3",
    image: image3,
    lottie: lottie3,
    url: song3,
  },
  {
    number: "4",
    image: image4,
    lottie: lottie4,
    url: song4,
  },
  {
    number: "5",
    image: image5,
    lottie: lottie5,
    url: song5,
  },
  {
    number: "6",
    image: image6,
    lottie: lottie6,
    url: song6,
  },
  {
    number: "7",
    image: image7,
    lottie: lottie7,
    url: song7,
  },
  {
    number: "8",
    image: image8,
    lottie: lottie8,
    url: song8,
  },
  {
    number: "9",
    image: image9,
    lottie: lottie9,
    url: song9,
  },
  {
    number: "10",
    image: image10,
    lottie: lottie10,
    url: song10,
  },
  {
    number: "11",
    image: image11,
    lottie: lottie11,
    url: song11,
  },
  {
    number: "12",
    image: image12,
    lottie: lottie12,
    url: song12,
  },
  {
    number: "13",
    image: image13,
    lottie: lottie13,
    url: song13,
  },
  {
    number: "14",
    image: image14,
    lottie: lottie14,
    url: song14,
  },
  {
    number: "15",
    image: image15,
    lottie: lottie15,
    url: song15,
  },
  {
    number: "16",
    image: image16,
    lottie: lottie16,
    url: song16,
  },
  {
    number: "17",
    image: image17,
    lottie: lottie17,
    url: song17,
  },
  {
    number: "18",
    image: image18,
    lottie: lottie18,
    url: song18,
  },
  {
    number: "19",
    image: image19,
    lottie: lottie19,
    url: song19,
  },
  {
    number: "20",
    image: image20,
    lottie: lottie20,
    url: song20,
  },
  {
    number: "21",
    image: image21,
    lottie: lottie21,
    url: song21,
  },
  {
    number: "22",
    image: image22,
    lottie: lottie22,
    url: song22,
  },
  {
    number: "23",
    image: image23,
    lottie: lottie23,
    url: song23,
  },
  {
    number: "24",
    image: image24,
    lottie: lottie24,
    url: song24,
  },
  {
    number: "25",
    image: image25,
    lottie: lottie25,
    url: song25,
  },
];

export default darkCalendar;
